import { ReporterErrorParams } from '../types';

export const reportErrorClient = async (params: ReporterErrorParams) => {
  const { reportError } = await import('./client');
  await reportError(params);
};
